import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'ags-info-indispo',
  templateUrl: './info-indispo.component.html',
  styleUrls: ['./info-indispo.component.scss']
})
export class InfoIndispoComponent implements OnInit {
  @Input() detail;
  constructor() {}

  ngOnInit() {}
}
